<template>
  <tr>
    <td v-if="environment.user_is_admin"><p class="text-left">
      <button @click="move(index,index-1)" :disabled="index==0">&#129093;</button>
      <button @click="move(index,index+1)" :disabled="index==(menu.items.length-1)">&#129095;</button>
    </p></td>
    <td><p class="text-left"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="nameHelp">{{ item.name }}</span></p></td>
    <td><p class="text-left"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="activeHelp"><span v-if="item.is_disabled == '0'">&#10004;</span></span></p></td>
    <td>
      <p class="text-left">
        <span v-if="languagesNames.length < 3" data-bs-toggle="tooltip" data-bs-placement="top" :title="languagesHelp">
          {{ languagesNames.join(', ') }}
        </span>
        <span v-if="languagesNames.length >= 3" data-bs-toggle="tooltip" data-bs-placement="top" :title="languagesNames.join(', ')">
          {{ languagesNames.length }} Idiomas &#9432;
        </span>
      </p>
    </td>
    <td><span data-bs-toggle="tooltip" data-bs-placement="top" :title="validDatesHelp"><p class="text-left" v-for="text in validDatesTexts">{{ text }}</p></span></td>
    <td>
      <p class="text-left">
        <span v-if="originCountries.length < 3" data-bs-toggle="tooltip" data-bs-placement="top" :title="userCountryHelp">
          {{ originCountries.join(', ') }}
        </span>
        <span v-if="originCountries.length > 3" data-bs-toggle="tooltip" data-bs-placement="top" :title="originCountries.join(', ')">
          {{ originCountries.length }} Países &#9432;
        </span>
      </p>
    </td>
    <td><p class="text-left"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="cssClassHelp">{{ item.css_class }}</span></p></td>
    <td><p class="text-left"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="mobileHelp"><span v-if="item.mobile == '1'">&#10004;</span></span></p></td>
    <td><p class="text-left"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="desktopHelp"><span v-if="item.desktop == '1'">&#10004;</span></span></p></td>
    <td><p class="text-left"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="tabletHelp"><span v-if="item.tablet == '1'">&#10004;</span></span></p></td>
    <td><p class="text-left"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="noFollowHelp"><span v-if="item.no_follow == '1'">&#10004;</span></span></p></td>
    <td>
      <router-link v-if="showEditOption" :to="editMenuItemUrl">
        <span data-bs-toggle="tooltip" data-bs-placement="top" title="Editar elemento del menú"><img src="../../assets/pencil.svg" alt="Editar elemento del menú"></span>
      </router-link>
    </td>
    <td v-if="environment.user_is_admin" class="text-center">
      <a href="#" onclick="return false;" >
        <span data-bs-toggle="tooltip" data-bs-placement="top" title="Eliminar elemento del menú" @click="deleteMenuItem(item.id)"><img src="../../assets/trashcan.svg" alt="Eliminar elemento del menú"></span>
      </a>
    </td>
  </tr>
</template>

<script>
import Url from '@/core/Url.js'
import Language from '@/utils/Language.js'
import Country from '@/utils/Country.js'
import HelpTexts from '@/utils/HelpTexts.js'

export default {
    name: 'menus-items-table-row',
    emits: ["delete_menu_item", "move"],
    props: {
      menu: {
        type: Object,
        default: {}
      },
      item: {
        type: Object,
        default: {}
      },
      environment: {
        type: Object,
        default: {}
      }
    },
    computed : {
        index: function () {
          return this.item.position - 1;
        },
        languagesNames: function () {
          let names = [];
          let languages = Object.keys(this.item.langs);
          if (languages.length) {
            let all_languages = Language.getLanguages();
            if (languages.length == Object.keys(all_languages).length) {
              names.push("Todos");
            } else {
              languages.forEach(function (language) {
                names.push(all_languages[language]);
              });
            }
          } else {
            names.push("Ninguno");
          }
          names.sort();
          return names;
        },
        validDatesTexts: function () {
          let texts = [];
          if (Array.isArray(this.item.valid_dates) && this.item.valid_dates.length) {
              this.item.valid_dates.forEach(function (dates) {
                let from = new Date(dates['from']);
                let to = new Date(dates['to']);
                let period = from.getDate() + "-" + (from.getMonth() + 1) + "-" + from.getFullYear() + " - "
                        + to.getDate() + "-" + (to.getMonth() + 1) + "-" + to.getFullYear();
                texts.push(period);
              });
          } else {
            texts = ["Todas"];
          }
          return texts;
        },
        originCountries: function () {
          let country_names = [];
          if (Array.isArray(this.item.origin_countries) && this.item.origin_countries.length) {
            let countries = Country.getCountries();
            this.item.origin_countries.forEach(function (country_id) {
              country_names.push(countries[country_id]);
            });
          } else {
            country_names.push("Todos");
          }
          country_names.sort();
          return country_names;
        },
        showEditOption: function () {
          return this.item.is_admin_reserved == '0' || (this.environment.user_is_admin && this.item.is_admin_reserved == '1');
        },
        editMenuItemUrl: function () {
          return Url.getEditMenuItemPath(this.menu.id, this.item.id);
        },
      isDisabledHelp: function () {
        return HelpTexts.getItemIsDisabledText();
      },
      nameHelp: function () {
        return HelpTexts.getItemNameText();
      },
      activeHelp: function () {
        return HelpTexts.getItemActiveText();
      },
      cssClassHelp: function () {
        return HelpTexts.getItemCssClassText();
      },
      mobileHelp: function () {
        return HelpTexts.getItemMobileText();
      },
      desktopHelp: function () {
        return HelpTexts.getItemDesktopText();
      },
      tabletHelp: function () {
        return HelpTexts.getItemTabletText();
      },
      noFollowHelp: function () {
        return HelpTexts.getItemNoFollowText();
      },
      targetBlankHelp: function () {
        return HelpTexts.getItemTargetBlankText();
      },
      userCountryHelp: function () {
        return HelpTexts.getItemUserCountryText();
      },
      validDatesHelp: function () {
        return HelpTexts.getItemValidDatesText();
      },
      languagesHelp: function () {
        return HelpTexts.getItemLanguagesText();
      },
    },
    methods : {
        deleteMenuItem (itemId) {
          this.$emit('delete_menu_item', itemId);
        },
        move(from, to) {
          this.$emit('move', {'from' : from, 'to' : to});
        }
    }
}
</script>
